import Styled, { css } from 'styled-components';

import { fadeInOut, ITransitionStates } from '../Animations/Animations';
import { cssDeclaration } from '../Utils';

export const TRANSITION_DURATION: number = 150;

interface IModalCenterProps {
  verticallyCenter?: boolean;
}

export const ModalOverlay = Styled.div<ITransitionStates & IModalCenterProps>`
  display: block;
  max-width: inherit;
  width: 100%;
  height: 100%;
  position: fixed;
  margin: 0 auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  transition: opacity ${TRANSITION_DURATION}ms ease-out;

  ${fadeInOut}

  ${({theme: { themeTwo }, verticallyCenter }) => {
    const { modal: { overlay }} = themeTwo;

    return css`
      z-index: ${themeTwo.global.zIndex.modal};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', overlay.backgroundColor)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', overlay.padding)};

      ${verticallyCenter && css`
        display: flex;
        padding-top: 0 !important;

        .center-modal {
          align-self: center;
          margin: auto;
        }
      `}
    `;
  }}
`;

export const CloseModalButton = Styled.button`
  position: absolute;
  right: 0;
  top: 0;

  ${({theme: { themeTwo }}) => {
    const { modal: { closeIcon }} = themeTwo;

    return css`
      /* padding */ ${cssDeclaration(themeTwo, 'padding', closeIcon.padding)}
    `;
  }}
`;
